import { useLocation } from "react-router-dom";

import BankResetAnnouncement from "web/Layout/BankResetAnnouncement";
import MBHeader from "web/Layout/MainHeader/Desktop/MBHeader";
import classes from "web/Layout/MainHeader/Mobile/mainHeader.scss";
import { moduleHeaderPaths } from "web/Layout/MainHeader/headerPaths";

import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

const MainHeaderDashboard = () => {
  const { data: company } = useGetCompanyDetailsQuery();
  const shouldShowMessage = company?.displayMessageOneTimeLossPoints || false;
  const { pathname } = useLocation();

  const moduleHeader = moduleHeaderPaths.find((item) =>
    pathname.startsWith(item.path)
  );

  if (!moduleHeader && pathname !== "/") {
    return null;
  }

  return (
    <header className={classes.root}>
      <MBHeader />
      <div>
        <BankResetAnnouncement shouldShowMessage={shouldShowMessage} />
      </div>
    </header>
  );
};

export default MainHeaderDashboard;
